import { RECEIVE_REFERRALS, REQUEST_REFERRALS } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_REFERRALS:
            return { ...state, shouldFetch: false }

        case RECEIVE_REFERRALS:
            return { ...state, ...data }

        default:
            return state
    }
}
